import React, { Component } from 'react';
import Radium from 'radium';
import PoolChart from '../../Common/poolChart'

class Pool extends Component {
  render() {
    const { employees, rootActivity, employees2 } = this.props;
    let employeeNodes = employees.map((employee, index) => {
      let acHours = 0
      employees2.forEach(element => {
        if (element.name == employee) {
          element.activities.forEach(a => {
            if (a.id === rootActivity.id) {
              acHours = a.hours
            }
          })

        }
      });
      return <div key={index} style={styles.employee}>{employee} - {acHours}</div>
    });

    return (
      <div className="row" style={styles.dayRegistration}>
        <PoolChart
          pool={rootActivity.pool}
          registered={rootActivity.registered}
        />
        {<div style={styles.employeesContainer}>
          <h4 style={styles.h4}>Mandskab</h4>
          {employeeNodes}
        </div>}
      </div>
    );
  }
}

var styles = {
  h4: {
    fontSize: '18px',
    fontWeight: '600',
    marginTop: '-11px',
    marginBottom: '28px'
  },
  dayRegistration: {
    paddingTop: '85px',
    height: '100%',
    textAlign: 'center'
  },
  employeesContainer: {
    marginTop: '40px',
    width: '100%',
    display: 'inline-block',
    padding: '12px'
  },
  employee: {
    width: '100%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    paddingLeft: '12px'
  }
}
export default Radium(Pool);


// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/Pool.jsx